// Helper analytics — invia eventi all'Edge Function `analytics-ingest`.
// ADR-001 / Fase A.3.
//
// Tutto fire-and-forget con try/catch silenzioso: i fallimenti analytics
// non devono MAI bloccare il flow utente.
//
// Uso `supabase.functions.invoke()` (non fetch manuale) perché aggiunge
// automaticamente sia `Authorization: Bearer <jwt>` sia `apikey: <anon_key>`,
// entrambi richiesti dal gateway Supabase per le function con verify_jwt: true.
//
// IMPORTANTE: trackLogout() va chiamato PRIMA di supabase.auth.signOut(),
// altrimenti il JWT è già stato revocato quando invoke() parte. Vedi
// performLogout() qui sotto.
import { supabase } from '../supabase'

const FUNCTION_NAME = 'analytics-ingest'
const STORAGE_KEY = 'analytics_session_id'

async function send(payload) {
  try {
    const body = {
      ...payload,
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
    }
    const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, { body })
    if (error) return null
    return data || null
  } catch {
    return null
  }
}

export async function trackLogin() {
  const out = await send({ event: 'login' })
  const sid = out?.session_id
  if (sid) {
    try { localStorage.setItem(STORAGE_KEY, sid) } catch {}
  }
  return sid || null
}

export async function trackLogout() {
  let sid = null
  try { sid = localStorage.getItem(STORAGE_KEY) } catch {}
  await send({ event: 'logout', session_id: sid || undefined })
  try { localStorage.removeItem(STORAGE_KEY) } catch {}
}

// Wrap di supabase.auth.signOut() che chiama trackLogout() PRIMA, mentre il
// JWT è ancora valido (race coperta: dopo signOut il client perde il token e
// la successiva invoke() arriverebbe alla function come invalid_jwt).
// Il try/catch su trackLogout è silenzioso per non bloccare il logout reale
// in caso di errore Edge Function (es. function down, rete, ecc.).
// Da usare al posto di supabase.auth.signOut() in tutti i punti dell'app.
export async function performLogout(supabaseClient = supabase) {
  try { await trackLogout() } catch {}
  return supabaseClient.auth.signOut()
}
